module.exports = function (eventName, eventData, data) {
  return this._pushLocalVersion(data);
};
